import PreviousImages from './PreviousImages';

export default PreviousImages;
